export const VISITOR_ID_COOKIE = 'visitor_id';
export const getCookie = (name) => {
    if (typeof document === 'undefined')
        return;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const cookieValue = parts.pop()?.split(';').shift();
        return cookieValue ?? undefined;
    }
};
export const getVisitorId = () => {
    return getCookie(VISITOR_ID_COOKIE);
};
